import React from 'react';

import "./Footer.css";

function Footer() {
    return (
        <section className='footer'>
            <div className='container'>
                <div className='row'>
                    <div className='col-12'>
                        Copyright © 2026, All Rights Reserved. Designed & Maintained By: <a href="#home">CDM</a>.
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Footer;
